import React from 'react'

import { AccordionContent, AccordionItem, Divider } from "./AssistanceServicesAccordion.Style"
import ContentSection from "../ContentSection"
import Accordion from "../../common/Accordion"

const emergencySituation = [
    {
        title: "Chaveiro",
        body: <>
            Se a porta externa for arrombada, a casa for assaltada ou simplesmente você perder as chaves, a gente manda alguém até você.
        </>
    },
    {
        title: "Eletricista",
        body: <>
            A gente envia eletricista para reparar o que for necessário para reestabelecer a energia elétrica ou solucionar problemas elétricos, dependendo do fato ocorrido.
        </>
    },
    {
        title: "Encanador",
        body: <>
            Conte com serviços de hidráulica em casos de emergência ou sinistro para reparar vazamento interno aparente que cause ou possa causar um alagamento.
        </>
    },
    {
        title: "Vidraceiro",
        body: <>
            Em caso de emergência, enviamos vidraceiro para consertar portas ou janelas externas de vidro.
            Caso não seja viável fazer o reparo na hora do atendimento, será colocado um tapume, provisoriamente, até que seja possível concluir o serviço.
            Essa assistência não inclui vidros de blindex, apenas vidros simples.
        </>
    },
    {
        title: "Conexão telefônica",
        body: <>
            Pelo telefone, você obtém indicações de prestadores de serviço e informações sobre o trânsito, clima, programação cultural e muito mais.
        </>
    },
]

const loanSituation = [
    {
        title: "Cobertura provisória de telhados",
        body: <>
            Em caso de emergência, enviamos um profissional para realizar a cobertura provisória do telhado com lona ou plástico.
        </>
    },
    {
        title: "Transporte e armazenamento de móveis",
        body: <>
            Caso você precise desocupar seu imóvel em consequência de alguma situação coberta pelo seguro, retiramos os móveis e transportamos para você.
        </>
    },
    {
        title: "Segurança e vigilância",
        body: <>
            Você tem direito a serviço de vigilante em seu imóvel, até 36h, caso ele fique vulnerável por danos ou prejuízos cobertos pelo seguro.
        </>
    },
    {
        title: "Limpeza do imóvel",
        body: <>
            Enviaremos  profissionais de limpeza até o seu imóvel, caso fique inabitável em consequência de fatos cobertos pelo seguro.
        </>
    },
]

const deathSituation = [
    {
        title: "Serviço de Assistência Funeral (SAF)",
        body: <>
            Em caso de morte natural ou acidental, nós realizamos o funeral do segurado. Essa cobertura é apenas para o Seguro Habitacional Mais Premiável.
        </>
    },
    {
        title: "Cesta básica",
        body: <>
            Em caso de morte natural ou acidental, disponibilizamos uma cesta básica no valor de R$ 150,00 durante 6 meses.
            Essa cobertura é apenas para o Seguro Habitacional Mais Premiável.
        </>
    },
]



const AssistanceServicesAccordion = ({ isMaisPremiavel = false }) => {
    return (
        <ContentSection title="Serviços de assistência">
            <AccordionContent>
                <AccordionItem>
                    <Accordion
                        titleAccordion="Situações emergenciais"
                        listItems={emergencySituation}
                    />
                </AccordionItem>
                <Divider />
                <AccordionItem>
                    <Accordion
                        titleAccordion="Em casos de sinistro"
                        listItems={loanSituation}
                    />
                </AccordionItem>
                {isMaisPremiavel && (<>
                    <Divider />
                    <AccordionItem>
                        <Accordion
                            titleAccordion="Em casos de morte"
                            listItems={deathSituation}
                        />
                    </AccordionItem>
                </>
                )
                }
            </AccordionContent>
        </ContentSection>
    )
}

export default AssistanceServicesAccordion